exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cls-2 {\n    fill: #72cac2!important;\n}\n  .includefilter {\n    width: 2.5rem;\n    padding-right: 0.5rem;\n    display: table;\n    float: left;\n    height: 2rem;\n    margin-bottom: 3rem;;\n  }", ""]);
